import { InjectionToken, Provider } from '@angular/core';
import { CountryCode } from 'libphonenumber-js';

export interface PhoneInputConfig {
  /** Countries to show at the top of the dropdown, separated by a divider. */
  preferredCountries?: CountryCode[];
  /** When set, restricts the dropdown to only these countries. */
  onlyCountries?: CountryCode[];
  /** Default country selection when no E164 value is present. Defaults to 'NL'. */
  defaultCountry?: CountryCode;
  /** Format the phone number as the user types (e.g. "06 12345678"). Defaults to true. */
  formatAsYouType?: boolean;
}

export const PHONE_INPUT_CONFIG = new InjectionToken<PhoneInputConfig>(
  'PHONE_INPUT_CONFIG'
);

export function providePhoneInputConfig(config: PhoneInputConfig): Provider {
  return { provide: PHONE_INPUT_CONFIG, useValue: config };
}
